import { ContextPack } from "@/api/studio/contexts/types/context.type";
import { Point } from "@/api/studio/data/types/point.type";
import { useEffect, useState } from "react";

/*
 * useDropzone hook
 */
export const useDropzone = (contextPack?: ContextPack, assetIndex?: number) => {
  /* State */
  const [dropzoneBackground, setDropzoneBackground] = useState<string>("#FFFFFF");
  const [showDropzoneBackground, setShowDropzoneBackground] = useState(false);
  const [points, setPoints] = useState<Point[]>([]);
  const [dropzoneId, setDropzoneId] = useState<string>("");

  /* Side effects */
  useEffect(() => {
    if (contextPack && assetIndex !== undefined && contextPack.contexts[assetIndex]?.dropzone?.points) {
      // set the default dropzone details if they exist on the context
      setPoints(contextPack.contexts[assetIndex].dropzone.points);
      setDropzoneBackground(contextPack.contexts[assetIndex].dropzone.backgroundColor);
      setShowDropzoneBackground(contextPack.contexts[assetIndex].dropzone.backgroundColor !== "#FFFFFF00");
    }
  }, [contextPack, assetIndex]);

  /* Handlers */
  const resetDropzoneBackground = () => {
    setDropzoneBackground("#FFFFFF");
    setShowDropzoneBackground(false);
  };

  /* Return */
  return {
    points,
    setPoints,
    dropzoneId,
    setDropzoneId,
    dropzoneBackground,
    setDropzoneBackground,
    showDropzoneBackground,
    setShowDropzoneBackground,
    resetDropzoneBackground,
  };
};
